export const taxonomiaEspecial = [
    {code:5, es:'Asistente Administrativa',en:'Administrative Assistant'},
    {code:6, es:'Asistente Ejecutiva',en:'Executive Assistant'},
    {code:7, es:'Asistente De Dirección General',en:'Assistant General Manager'},
]